import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import { IAllDistributions, IClass } from "../../../state";
import BarChartAssessmentDistribution from "../../../atoms/BarChartAssessmentDistribution";
import Spinner from "../../../atoms/Spinner";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/caret_down.svg";
import { assessmentByClassPath } from "../../../teacherStore";
import DropdownAssessment from "../../../atoms/DropdownAssessment";

import styles from "./AllAssessmentDistribution.module.scss";

export type Props = {
  loading?: boolean;
  currentClass: IClass;
  allDistributions: IAllDistributions;
};

const options = [
  { value: 0, label: "初回・現在" },
  { value: 1, label: "前回・現在" },
];

export enum DistributionType {
  past = "past",
  current = "current",
}

const AllAssessmentDistribution: React.FC<Props> = ({
  loading,
  currentClass,
  allDistributions,
}) => {
  const [selectedDropDown, setSelectedDropdown] = React.useState(
    options[0].value,
  );

  const dataDistribution = React.useMemo(() => {
    if (
      !allDistributions.first_term_no_distributions ||
      !allDistributions.last_term_no_distributions ||
      !allDistributions.previous_term_no_distributions
    )
      return [];
    const selectedPastDistribution = selectedDropDown
      ? {
          type: DistributionType.past,
          distributions: allDistributions.previous_term_no_distributions,
        }
      : {
          type: DistributionType.past,
          distributions: allDistributions.first_term_no_distributions,
        };

    const lastDistributionData = {
      type: DistributionType.current,
      distributions: allDistributions.last_term_no_distributions,
    };

    const distributionData = [lastDistributionData, selectedPastDistribution];

    const data: {
      type: DistributionType;
      distributions: {
        student: number[][];
      };
    }[] = distributionData.map(distribution => ({
      type: distribution.type,
      distributions: {
        student: distribution.distributions.map(student =>
          Object.values(student.by_student_score).reverse(),
        ),
      },
    }));
    const distributionTypeOrder = Object.values(DistributionType);

    return data.sort(
      (a, b) =>
        distributionTypeOrder.indexOf(a.type) -
        distributionTypeOrder.indexOf(b.type),
    );
  }, [selectedDropDown, allDistributions]);

  return (
    <div className={clsx(styles.wrapper)}>
      <div className={styles.topContent}>
        <Link to={`${assessmentByClassPath}?class_id=${currentClass.id}`}>
          <ArrowIcon /> 戻る
        </Link>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.contentWrapper}>
          <div className={styles.headerTitle}>
            <span>{currentClass.full_name}</span>
          </div>
          {loading && <Spinner className={styles.loading} />}
          <div className="d-flex align-items-center justify-content-between">
            <div className={styles.labelTitle}>全素養分布図</div>
            <DropdownAssessment
              options={options}
              defaultValue={options[0]}
              className={styles.dropTerm}
              onChange={setSelectedDropdown}
            />
          </div>
          <div className={styles.summary}>
            <BarChartAssessmentDistribution dataChart={dataDistribution} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllAssessmentDistribution;
